export default "__VITE_ASSET__CZt$0wQx__"